const waitForFormEmbed = setInterval(() => {
  const template = window.templateName

  const formEmbed = document.querySelector(
    ".newsletter-wrap__container form-embed"
  )

  if (formEmbed && formEmbed.shadowRoot) {
    const formWrap = formEmbed.shadowRoot.querySelector(
      'section[data-sizing="form-wrapper"]'
    )
    const fieldset = formEmbed.shadowRoot.querySelector(
      'form[class*="_formFieldset"]'
    )
    const shadowRoot = formEmbed.shadowRoot

    if (formWrap) {
      formWrap.style.maxWidth = "100%"
    }

    if (fieldset) {
      const style = document.createElement("style")
      style.textContent = `
          form[class*="_formFieldset"] {
            flex-direction: row !important;
            gap: 12px !important;
          }

          section[data-sizing="form-wrapper"] {
            max-width: 100% !important;
            min-height: 0 !important;
            padding-bottom: 1px !important;
          }

          section[data-sizing="form-wrapper"] input::placeholder {
            color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};
            opacity: 1;
          }

          section[data-sizing="form-wrapper"] input {
            box-sizing: border-box;
            max-width: 380px;
            width: 380px;
            position: relative;
            min-height: 3.25rem;
            border-width: 1px;
            border-radius: 2.5rem;
            padding-block: 0.75rem;
            border-style: solid;
            border-color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};
            padding-inline: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5rem;
            background-color: transparent;
            color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};
            margin-top: 1px;
          }
          
          section[data-sizing="form-wrapper"] div[class*="_withError"] input,
          section[data-sizing="form-wrapper"] div[class*="_withError"] textarea {
            border-width: 1px;
            box-shadow: unset;
            border-color: rgba(var(--color-utility-error));
          }

          section[data-sizing="form-wrapper"] output {
            display: none;
          }

          section[data-sizing="form-wrapper"] input:focus,
          section[data-sizing="form-wrapper"] input:focus-visible {
            outline-width: 0px;
            border: 1px solid;
            border-color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-accents-green))' : 'rgb(var(--color-accents-yellow))'};
            box-shadow: unset;
          }

          section[data-sizing="form-wrapper"] input + label {
            display: none;
          }

          section[data-sizing="form-wrapper"] button {
            position: relative;
            font-size: 0.8125rem;
            line-height: 1rem;
            font-weight: 700;
            letter-spacing: 0.4px;
            text-align: center;
            text-transform: uppercase;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 3.75rem;
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 300ms;
            background-color: transparent;
            border-width: 1px;
            border-style: solid;
            border-color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};
            padding-inline: 2rem;
            padding-block: 1rem;
            color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};
          }

          section[data-sizing="form-wrapper"] button:hover {
            border-color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};
            background-color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};
            color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-white))' : 'rgb(var(--color-primary-black))'};
            filter: none;
            border-width: 1px;
            border-style: solid;
          }

          section[data-sizing="form-wrapper"] section[data-testid="banner-success"] h2 {
            font-family: var(--font-body);
            font-weight: 700;
            font-size: 0.875rem;
            line-height: 1.25rem;
            letter-spacing: 1.4px;
            text-transform: uppercase;
            color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};;
            justify-content: left;
          }
    
          section[data-sizing="form-wrapper"] section[data-testid="banner-success"] p {
             font-family: var(--font-heading);
            font-size: 2.5rem;
            line-height: 3.5rem;
            letter-spacing: 0.6px;
            text-transform: none;
            color: ${template && (template == 'article' || template == 'contact-us') ? 'rgb(var(--color-primary-black))' : 'rgb(var(--color-primary-white))'};;
            text-align: left;
          }

          @media (min-width: 990px) and (max-width: 1210px) {
            section[data-sizing="form-wrapper"] input {
              max-width: 280px;
              width: 280px;
            }
          }

          @media (max-width: 990px) {
            form[class*="_formFieldset"] {
              flex-direction: column !important;
              gap: 14px !important;
            }

             section[data-sizing="form-wrapper"] input {
              max-width: 100%;
              width: 100%;
            }

            div[data-testid="app-router"] {
              display: block;
            }

            section[data-sizing="form-wrapper"] section[data-testid="banner-success"] h2 {
              font-size: 0.6875rem;
              line-height: 1rem;
              letter-spacing: 1px;
            }

            section[data-sizing="form-wrapper"] section[data-testid="banner-success"] p {
               font-size: 1.625rem;
                line-height: 2.25rem;
            }
          }
        `
      shadowRoot.appendChild(style)
      fieldset.querySelectorAll("input").forEach((input) => {
        input.placeholder = input.nextElementSibling.innerText
      })
      clearInterval(waitForFormEmbed)
    }
  }
}, 200)
